import { ContenuPosePushVideo } from '@components/contenu-pose-push-video/models';
import { Block } from '@shared/models';

export const contenuPosePushVideoMock: Block<ContenuPosePushVideo> = {
  type: 'contenu-pose-push-video',
  data: {
    titleWithText: {
      title: {
        text: `Faites confiance à\\\\[[nos poseurs !]]`,
        as: 'h2',
      },
      text: `Profitez de notre expertise et de nos garanties et confiez l'installation de votre cuisine à un <strong>professionnel</strong> SoCoo'c les yeux fermés. Nos poseurs sont sélectionnés avec exigence et reconnus pour leur professionnalisme. Et en plus, ils sont super sympas !`,
    },
    youtubeContent: {
      title: {
        text: `Mais au fait, une pose\\\\[[ça se passe comment ?]]`,
        as: 'h2',
      },
      link: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', // or https://youtu.be/dQw4w9WgXcQ?si=rtaZJ33e1DWriws5
    },
    cta: {
      label: `Voir la formule "Je pose moi-même"`,
      url: `/mock-la-pose/perso`,
    },
  },
};
